module.exports = __webpack_public_path__ + "static/media/bio.cd78cf30.jpg";